import { Box } from '@mui/material';

type CustomDateHourCellProps = {
    timeValue: string;
    dateValue: string;
};

export const CustomDateHourCell = ({ dateValue, timeValue }: CustomDateHourCellProps) => {
    return (
        <Box>
            <Box>{dateValue}</Box>
            <Box sx={{ fontWeight: 'bold' }}>{timeValue}</Box>
        </Box>
    );
};
